import {useActions, useGetters, useMutators, useState} from './_default';
import {getFormLocalStorage, storeToLocalStorage} from "@/js/helpers.js";
export default {
    namespaced: true,
    state: {
        ...useState(),
        expanded: null,
        root: null,
        navigateAndCollapse: false,

    },
    getters: {
        ...useGetters(),
        navigateAndCollapse: state => state.navigateAndCollapse,
        expanded(state) {
            if (state.expanded === null) {
                state.expanded = getFormLocalStorage('sidebar', '1') === '1';
            }
            return state.expanded;
        },
        flatList(state) {
            const flatList = [];
            state.list.forEach((link) => {
                addLinkToFlatList(link, flatList);
            });
            return flatList;
        },
    },
    mutations: {
        ...useMutators(),
        navigateAndCollapse(state, status) {
          state.navigateAndCollapse = status;
        },
        expanded(state, status) {
            state.expanded = status;
            storeToLocalStorage('sidebar', status ? 1 : 0);
        },
    },
    actions: {
        ...useActions(),
    },
}

function addLinkToFlatList(link, list) {
    list.push(link);

    link.children.forEach((link) => {
        addLinkToFlatList(link, list);
    });

    link.subcategories.forEach((link) => {
        addLinkToFlatList(link, list);
    });
}
